export default {
  ReceiptProcess: {
    Disconnect: 'Ngắt kết nối',
    Connect: 'Kết nối',
    Connecting: 'Đang kết nối',
    Disconnecting: 'Chưa kết nối',
  },
  ReceiptList: {
    Title: 'Biên lai',
    ReceiptFromMISAMelnvoice: 'Lấy biên lai từ MISA melnvoice',
    CreateReceiptVoucher: 'Lập phiếu thu',
    ViewReceipt: 'Xem',
  },
  ReceiptDetail: {
    Title: 'Biên lai',
    Cash: 'Tiền mặt',
    Deposit: 'Tiền gửi',
    AccountObjectID: 'Người nộp tiền',
    AccountObjectName: 'Họ tên',
    AccountObjectAddress: 'Địa chỉ',
    AccountObjectTaxCode: 'Mã số thuế',
    Buyer: 'Người nhận biên lai',
    PaymentMethod: 'Hình thức thanh toán',
    CTReference: 'CT tham chiếu',
    CTReferenceTooltip: 'Chứng từ tham chiếu',
    InvTemplateNo: 'Mẫu số BL',
    InvTemplateNoTooltip: 'Mẫu số biên lai',
    InvSeries: 'Ký hiệu BL',
    InvSeriesTooltip: 'Ký hiệu biên lai',
    InvNo: 'Số biên lai',
    InvDate: 'Ngày biên lai',
    Close: 'Đóng',
    CloseTooltip: 'Đóng (ESC)',
    Print: 'In',
    Refresh: 'Nạp',
    Postpone: 'Hoãn',
    PostponeTooltip: 'Hoãn (Ctrl + U)',
    RefreshTooltip: 'Nạp (Ctrl + R)',
    CreateReceiptVoucher: 'Lập phiếu thu',
    CreateReceiptVoucherTooltip: 'Lập phiếu thu ( Ctrl + S )',
  },
  ReceiptVoucherDetail: {
    Title: 'Phiếu thu tiền',
    Status: 'Đã lập biên lai',
    AccountObjectID: 'Người nộp',
    AccountObjectName: 'Họ tên',
    AccountObjectAddress: 'Địa chỉ',
    BankInfo: 'TKKB',
    BankInfoTooltip: 'Tài khoản Kho bạc',
    Description: 'Diễn giải',
    Attach: 'Kèm theo',
    RefDate: 'Ngày PT',
    RefDateTooltip: 'Ngày phiếu thu',
    PostedDate: 'Ngày HT',
    PostedDateTooltip: 'Ngày hạch toán',
    RefNo: 'Số PT',
    RefNoTooltip: 'Số phiếu thu',
    GBNNo: 'Số GBN',
    GBNNoTooltip: 'Số GBN',
  },
};
